module.exports = __webpack_public_path__ + "img/French.a68a5fa3.svg";